import React, { useContext, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Form } from "react-bootstrap";
import "./LoginForm.modules.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Button, IconButton } from "@mui/material";
import AuthContext from "../../context/user-auth/AuthProvider";
import AuthVerficationOtp from "../modals/auth_varification/AuthVerficationOtp";
import Newpassword from "../modals/new_password/Newpassword";
import Forgetpassword from "../modals/forgot_password/Forgetpassword";
import CryptoJS from 'crypto-js';

export default function LoginForm() {
  const { loginUser, isLoading, generateOpt,generateSessionID } = useContext(AuthContext);
  const [showPassword, setShowPassword] = React.useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const navigate = useNavigate();

  const { email, password } = formData;

  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const shownewpasswordmodal = () => {
    setShowForgotPassword(false);
    setShowNewPassword(true);
  }


  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleForgotPassword = () => setShowForgotPassword((show) => !show);
  function generateUUID4() {
    return (String(1e7) + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (Number(c) ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (Number(c) / 4)))).toString(16)
    );
  }
  function base64ToHex(str) {
    const raw = window.atob(str);
    let result = '';
    for (let i = 0; i < raw.length; i++) {
      const hex = raw.charCodeAt(i).toString(16);
      result += (hex.length === 2 ? hex : '0' + hex);
    }
    return result;

  }
  function encryptUsingAES256(securityKey,initVector,pwd) {
    let _key = securityKey;
    let _iv = initVector;
    if (_key) {
      let encrypted = CryptoJS.AES.encrypt(pwd, CryptoJS.enc.Hex.parse(_key), {
        keySize: 32,
        iv: CryptoJS.enc.Hex.parse(_iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7

      });
      let encepKey = base64ToHex(encrypted.toString());
      return encepKey;

    }

  }
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const local_SID = localStorage.getItem("SID");
    if(local_SID)
    {
      const session_response = await generateSessionID({ "sessionID": local_SID });
      if(session_response.success)
      {
        let encpwd=encryptUsingAES256(session_response.data.security_key, session_response.data.vector_key,password)
        const response = await loginUser({ email, password:encpwd,sessionID:local_SID });
          if (response.success && response.message === "Login Successfull") {
            setFormData({
              email: "",
              password: "",
            });
            navigate("/", {state: {
              newUser: response.data.isNewLogin 
            }});

          } 
          else if (response.success && response.message === "MFA Options") {
            setShowAuthModal(true);
            window.$userId = response?.data.user_id;
            const dataResp = await generateOpt({
              id: response?.data.user_id,
              type: "Email",
            });
            if (dataResp.success) {
              setShowAuthModal(true);
            }
          } 
          else {
            navigate("/login");
          }
      }
      else
      {
        navigate("/login");
      }
     
      
    }
    else
    {
      let sessionID= generateUUID4();
      const session_response = await generateSessionID({ "sessionID": sessionID });
      if(session_response.success)
      {
        localStorage.setItem("SID",sessionID);
        let encpwd=encryptUsingAES256(session_response.data.security_key, session_response.data.vector_key,password)
      const response = await loginUser({ email, password:encpwd,sessionID:sessionID });
        if (response.success && response.message === "Login Successfull") {
          setFormData({
            email: "",
            password: "",
          });
          navigate("/", {state: {
            newUser: response.data.isNewLogin 
          }});
          
        } 
        else if (response.success && response.message === "MFA Options") {
          setShowAuthModal(true);
          window.$userId = response?.data.user_id;
          const dataResp = await generateOpt({
            id: response?.data.user_id,
            type: "Email",
          });
          if (dataResp.success) {
            setShowAuthModal(true);
          }
        } 
        else {
          navigate("/login");
        }
      }
      else
      {
        navigate("/login");
      }
    }
   
    
  };

  const canSubmit = Boolean(email) && Boolean(password);

  return (
    <>
      <Form id="loginForm" onSubmit={handleSubmit}>
        <div className="input-group mb-3">
          <FontAwesomeIcon icon={faEnvelope} className="position-absolute top-50 translate-middle-y text-muted fs-base ms-3" />
          <input type="text" className="form-control rounded-start" id="email" name="email" value={email} placeholder="Enter your Email ID or Login ID" onChange={onChange} />
        </div>
        <div className="input-group mb-3">
          <input type={showPassword ? "text" : "password"} className="form-control rounded-start" id="password" name="password" value={password} placeholder="Enter password" onChange={onChange} />
          <IconButton aria-label="toggle password visibility" className="position-absolute ms-auto top-50 translate-middle-y text-muted fs-base" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">
            {showPassword ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        </div>
        <div className="d-flex flex-wrap justify-content-end">
          <div role={"button"} onClick={handleForgotPassword} className="nav-link-inline fs-sm fw-bold" href="account-password-recovery.html">
            Forgot password?
          </div>
        </div>
        <Button variant="contained" className={`mt-2 ${isLoading ? "btn-loading" : ""}`} fullWidth color="error" title="Sign In" disabled={!canSubmit || showForgotPassword || showAuthModal || showForgotPassword} type="submit">
          Sign In
        </Button>
      </Form>
      {showForgotPassword && (
        <Forgetpassword
          shownewpasswordmodal={shownewpasswordmodal}
          show={showForgotPassword}
          onHide={() => setShowForgotPassword(false)}
        />
      )}

      {showAuthModal && <AuthVerficationOtp email={email} show={showAuthModal} onHide={() => setShowAuthModal(false)} />}

      {showNewPassword && (
        <Newpassword
          showauthmodal={() => {
            setShowAuthModal(true);
            setShowNewPassword(false);
          }}
          show={showNewPassword}
          onHide={() => setShowNewPassword(false)}
        />
      )}
    </>
  );
}